/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 09:57:41
 */

import DeclareMalfunction from '../declareMalfunction';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import DeclareMalfunctionApi, { DeclareMalfunctionDOI } from '../api/declareMalfunctionApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import EnumOperates from 'src/enums/enumOperates';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import EnumMalfunctionAuditStatus from 'src/enums/enumMalfunctionAuditStatus';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import Input from 'src/types/iview/Input';
import alertAuditMalfunctionModal from '../auditMalfunctionModal';
import alertOperateMalfunctionModal from '../operateMalfunctionModal';
import alertBatchAuditModal from '../../declareMaintenance/batchAuditModal';

export default class DeclareMalfunctionService extends ListPageService {
    ctx: DeclareMalfunction;

    constructor(ctx: DeclareMalfunction) {
        super();
        this.ctx = ctx;
    }
    // 是否是申报
    get isDeclare() {
        return this.ctx.$route.name === 'maintenance-manage-declare-malfunction';
    }
    get isAudit() {
        return this.ctx.$route.name === 'maintenance-manage-audit-malfunction';
    }
    get isSubmit() {
        return this.ctx.$route.name === 'maintenance-manage-submit-malfunction';
    }
    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '故障单号',
                field: 'fault_number',
                minWidth: 80,
                cellRendererFramework: CellRenderTsx,
                cellRendererFrameworkOpt: {
                    cellRender(h, params) {
                        let data: DeclareMalfunctionDOI.RowDataI = params.data;
                        return (
                            <div
                                class="wqms-cursor wqms-link"
                                on-click={() => {
                                    alertAuditMalfunctionModal(EnumOperates.Detail.getName(), data.id, data.fault_number);
                                }}
                            >
                                {data.fault_number}
                            </div>
                        );
                    },
                },
            },
            {
                headerName: '发起人',
                field: 'initiator',
                minWidth: 100,
            },
            {
                headerName: '发起时间',
                field: 'sponsor_datetime',
                minWidth: 170,
            },
            {
                headerName: '故障站点',
                field: 'fault_site',
                minWidth: 140,
                cellRenderer(params) {
                    let data: DeclareMalfunctionDOI.RowDataI = params.data;
                    data.fault_site = data.fault_site||{data:[]}
                    return data.fault_site.data.map(i=>i.operational_site).join(',')
                },
            },
            {
                headerName: '申报类型',
                field: 'declare_type',
                minWidth: 100,
            },
            {
                headerName: '原因',
                field: 'cause',
                minWidth: 100,
            },
            {
                headerName: '审核状态',
                field: 'status',
                minWidth: 100,
                cellRenderer(params) {
                    let data: DeclareMalfunctionDOI.RowDataI = params.data;
                    return EnumMalfunctionAuditStatus.findId(data.status).getName();
                },
            },
            {
                headerName: '审核人',
                field: 'auditor',
                minWidth: 100,
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 120,
                maxWidth: 120,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        hide: !t.isDeclare,
                        disabled(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            return EnumMalfunctionAuditStatus.待提交.getId()!==data.status;
                        },
                        async click(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            let res = await alertOperateMalfunctionModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        hide: !t.isDeclare,
                        disabled(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            return [EnumMalfunctionAuditStatus.不提交.getId(), EnumMalfunctionAuditStatus.审核通过.getId(),EnumMalfunctionAuditStatus.待审核.getId()].includes(data.status)
                        },
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                    {
                        text: '审核',
                        hide: !t.isAudit,
                        disabled(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            return data.status !== EnumMalfunctionAuditStatus.待审核.getId()
                        },
                        async click(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            let res = await alertAuditMalfunctionModal(EnumOperates.Audit.getName(), data.id, data.fault_number);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },{
                        text: '提交',
                        disabled(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            return data.status !== EnumMalfunctionAuditStatus.待提交.getId()
                        },
                        hide: !t.isSubmit,
                        async click(params) {
                            let data: DeclareMalfunctionDOI.RowDataI = params.data;
                            let res = await alertAuditMalfunctionModal(EnumOperates.Submit.getName(), data.id, data.fault_number);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                ],
            },
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '申报类型：',
                field: 'declare_type',
                props: { value: null, type: EnumEntity.DeclareType.getId() },
            },
            {
                component: CommonSelect,
                label: '状态：',
                field: 'status',
                props: { value: null, dataSource: EnumMalfunctionAuditStatus.getList() },
            },
            {
                component: DatePicker,
                label: '发起时间',
                field: 'time',
                width: 300,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: { value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd', placeholder: '请选择时间' },
            },
            {
                component: Input,
                labelWidth: 20,
                label: '',
                field: 'keyword',
                props: { value: '', placeholder: '请输入' },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await DeclareMalfunctionApi.delete({ ids });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }
    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        if (this.isDeclare) {
            return [
                {
                    text: '新增',
                    async onClick() {
                        let res = await alertOperateMalfunctionModal(EnumOperates.Add.getName());
                        if (res) {
                            t.searchTable();
                        }
                    },
                },
                {
                    text: '删除',
                    type: 'info',
                    async onClick() {
                        let gridOptions: any = t.ctx.gridOptions;
                        let selectRows: DeclareMalfunctionDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                        if (selectRows.length === 0) {
                            return Toast.warning('请选择要操作的数据');
                        }
                        if(selectRows.some(i=> [EnumMalfunctionAuditStatus.不提交.getId(), EnumMalfunctionAuditStatus.审核通过.getId(),EnumMalfunctionAuditStatus.待审核.getId()].includes(i.status))) {
                            return Toast.warning('已提交数据不能删除！');
                        }
                        let res = await Toast.confirm();
                        if (!res) {
                            return;
                        }
                        let ids: number[] = selectRows.map(item => item.id);
                        await t.delete(ids);
                    },
                },
            ];
        } else if (this.isAudit) {
            return [
                {
                    text: '批量审核',
                    async onClick() {
                        let res = await EnumOperates.Add.getName();
                        if (res) {
                            let gridOptions: any = t.ctx.gridOptions;
                            let selectRows: DeclareMalfunctionDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                            if (selectRows.length === 0) {
                                return Toast.warning('请选择要操作的数据');
                            }
                            if(selectRows.some(i=> i.status !== EnumMalfunctionAuditStatus.待审核.getId())) {
                                return Toast.warning('请选择待审核的数据');
                            }
                            let ids: number[] = selectRows.map(item => item.id);
                            let res = await alertBatchAuditModal(ids, DeclareMalfunctionApi.batchAudit);
                            if (res) {
                                t.searchTable();
                            }
                        }
                    },
                },
            ];
        } else {
            return [
                {
                    text: '批量提交',
                    async onClick() {
                        let res = await EnumOperates.Add.getName();
                        if (res) {
                            let gridOptions: any = t.ctx.gridOptions;
                            let selectRows: DeclareMalfunctionDOI.RowDataI[] = gridOptions.api.getSelectedRows();
                            if (selectRows.length === 0) {
                                return Toast.warning('请选择要操作的数据');
                            }
                            if(selectRows.some(i=> i.status !== EnumMalfunctionAuditStatus.待提交.getId())) {
                                return Toast.warning('请选择待提交的数据');
                            }
                            let ids: number[] = selectRows.map(item => item.id);
                            let res = await alertBatchAuditModal(ids, DeclareMalfunctionApi.batchSubmit, true);
                            if (res) {
                                t.searchTable();
                            }
                        }
                    },
                },
            ];
        }
    }
    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<DeclareMalfunctionDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await DeclareMalfunctionApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
